export enum PracticeTypes {
    COMPET = "Compétition",
    CASUAL = "Loisir",
    HANDFIT = "HandFit",
    DIRIGEANT = "Dirigeant",
}